// src/components/UserMenuTab.jsx
// Tab แสดงรายการ menus ที่ user คนนี้เห็นได้ (ผ่าน USER_ROLE_ID)
// ใช้ใน UserDetail โดยสลับกับ tab "Info"

import React, { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";

function MenuRow({ item, depth = 0 }) {
  return (
    <div style={{
      display:     "flex",
      alignItems:  "center",
      gap:         8,
      padding:     "7px 12px",
      paddingLeft: depth * 20 + 12,
      borderBottom: "1px solid #f8fafc",
      background:  depth === 0 ? "#fafafa" : "#fff",
    }}>
      {/* Icon */}
      <i
        className={`ti ${item.MENU_ICON || "ti-square"}`}
        style={{ fontSize: 15, color: "#64748b", width: 18, textAlign: "center", flexShrink: 0 }}
      />

      {/* Name */}
      <span style={{
        flex: 1, fontSize: 13,
        fontWeight: depth === 0 ? 600 : 400,
        color: "#1e293b",
      }}>
        {item.MENU_TEXT}
      </span>

      {/* URL */}
      <span style={{
        fontSize: 11, color: "#94a3b8",
        fontFamily: "monospace", flexShrink: 0,
        maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
      }}>
        {item.MENU_URL || "—"}
      </span>

      {/* CAN_EDIT badge */}
      <span style={{
        fontSize: 10, padding: "2px 7px", borderRadius: 10, fontWeight: 700, flexShrink: 0,
        background: item.CAN_EDIT ? "#fef9c3" : "#f1f5f9",
        color:      item.CAN_EDIT ? "#92400e" : "#94a3b8",
      }}>
        {item.CAN_EDIT ? "Edit" : "View"}
      </span>
    </div>
  );
}

function buildTree(rows) {
  const map   = {};
  rows.forEach(r => { map[r.MENU_ID] = { ...r, children: [] }; });
  const roots = [];
  rows.forEach(r => {
    if (r.MENU_PARENT_ID && map[r.MENU_PARENT_ID]) {
      map[r.MENU_PARENT_ID].children.push(map[r.MENU_ID]);
    } else {
      roots.push(map[r.MENU_ID]);
    }
  });
  const sort = nodes => {
    nodes.sort((a, b) => a.MENU_SEQ - b.MENU_SEQ);
    nodes.forEach(n => sort(n.children));
    return nodes;
  };
  return sort(roots);
}

function TreeRows({ nodes, depth = 0 }) {
  return nodes.map(n => (
    <React.Fragment key={n.MENU_ID}>
      <MenuRow item={n} depth={depth} />
      {n.children.length > 0 && <TreeRows nodes={n.children} depth={depth + 1} />}
    </React.Fragment>
  ));
}

export function UserMenuTab({ userId, roleId, roleName }) {
  const { userMenus, loading, error, fetchUserMenus } = useAuth();

  useEffect(() => {
    if (userId) fetchUserMenus(userId);
  }, [userId, fetchUserMenus]);

  const tree = buildTree(userMenus);

  return (
    <div style={{ padding: "16px 20px" }}>
      {/* Role info */}
      <div style={{
        display:      "flex",
        alignItems:   "center",
        gap:          10,
        marginBottom: 14,
        padding:      "10px 14px",
        background:   "#eff6ff",
        borderRadius: 8,
        border:       "1px solid #bfdbfe",
      }}>
        <i className="ti ti-shield-check" style={{ fontSize: 16, color: "#1d4ed8" }} />
        <div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#1d4ed8" }}>
            Role: {roleName || `ID ${roleId}`}
          </span>
          <span style={{ fontSize: 11, color: "#64748b", marginLeft: 10 }}>
            เห็นทั้งหมด {userMenus.length} เมนู
          </span>
        </div>
      </div>

      {/* Loading / Error */}
      {loading && (
        <div style={{ padding: 24, textAlign: "center", color: "#64748b", fontSize: 13 }}>
          ⏳ กำลังโหลด...
        </div>
      )}
      {error && (
        <div style={{
          padding: "10px 14px", background: "#fef2f2",
          color: "#dc2626", borderRadius: 6, fontSize: 13, marginBottom: 12,
        }}>
          ❌ {error}
        </div>
      )}

      {/* Menu tree */}
      {!loading && !error && (
        userMenus.length === 0 ? (
          <div style={{ padding: 32, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>
            <i className="ti ti-eye-off" style={{ fontSize: 32, display: "block", marginBottom: 8, opacity: 0.3 }} />
            ยังไม่มีเมนูที่กำหนดสิทธิ์สำหรับ role นี้
          </div>
        ) : (
          <div style={{
            border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden",
          }}>
            {/* Header */}
            <div style={{
              display: "flex", gap: 8, padding: "8px 12px",
              background: "#f1f5f9", borderBottom: "1px solid #e2e8f0",
            }}>
              <span style={{ flex: 1, fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase" }}>Menu</span>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", width: 180 }}>URL</span>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", width: 50 }}>สิทธิ์</span>
            </div>
            <TreeRows nodes={tree} />
          </div>
        )
      )}
    </div>
  );
}
